import GlobeEuropeAfricaIcon from '@heroicons/react/24/solid/GlobeEuropeAfricaIcon';
import { Grid, InputAdornment, SvgIcon } from '@mui/material';

import { FlotaAndServiceActivationInstallPart } from '@/erp/operaciones/activaciones/instalaciones/shared/components/form/components';
import { gridSize, gridSizeMdLg6, useLoaders, useMapComponent } from '@/shared';
import { IconBtnModalMapComponent } from '@/shared/components/erp';
import {
  CustomTextField,
  CustomTextFieldNoForm,
  TabTextLabel,
} from '@/shared/components/ui';
import { OrdenTrabajo } from '@/shared/interfaces';
//import { SaveOperacionTenicoPreRechazadoForm } from './SaveOperacionTenicoPreRechazado';

export type OperacionPrerechazadaInstallDetailProps = {
  form: any; // to prevent vscode problems (slow typing)
  //form: UseFormReturn<SaveOperacionTenicoPreRechazadoForm>;
  ordenTrabajo: OrdenTrabajo;
};

const OperacionPrerechazadaInstallDetail: React.FC<
  OperacionPrerechazadaInstallDetailProps
> = ({ form, ordenTrabajo }) => {
  ///* form ------------------------
  const { errors } = form?.formState || {};
  const shrink = true;

  ///* map ------------------------
  const {
    Map,
    latLng,
    setLatLng,
    isLoadingNapsByCity,
    isRefetchingNapsByCity,
    napsByCity,
  } = useMapComponent({
    form,
    currentCity: '', // replaced by coordenadasCliente
    distanciaNapKey: 'distancia',
    coordenadasCliente: form?.getValues()?.coordenadas || '',
  });

  ///* effects ---------------------
  useLoaders(isLoadingNapsByCity || isRefetchingNapsByCity);

  return (
    <>
      {/* -------- View data servicio ---------- */}
      <FlotaAndServiceActivationInstallPart
        form={form}
        ordenTrabajo={ordenTrabajo}
      />

      {/* ------- cliente --------- */}
      <TabTextLabel text="Cliente" pt="42px" />
      <>
        {/* ------- view ------- */}
        <>
          {/* ========== location ========== */}
          <CustomTextField
            name="pais"
            label="País"
            control={form.control}
            defaultValue={form.getValues().pais || ''}
            error={errors.pais}
            helperText={errors.pais?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextField
            name="ciudad"
            label="Ciudad"
            control={form.control}
            defaultValue={form.getValues().ciudad || ''}
            error={errors.ciudad}
            helperText={errors.ciudad?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextField
            name="zona"
            label="Zona"
            control={form.control}
            defaultValue={form.getValues().zona || ''}
            error={errors.zona}
            helperText={errors.zona?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextField
            name="sector"
            label="Sector"
            control={form.control}
            defaultValue={form.getValues().sector || ''}
            error={errors.sector}
            helperText={errors.sector?.message?.toString() ?? ''}
            shrink={shrink}
            size={gridSizeMdLg6}
            disabled
          />
          <CustomTextField
            name="direccion"
            label="Dirección"
            control={form.control}
            defaultValue={form.getValues().direccion || ''}
            error={errors.direccion}
            helperText={errors.direccion?.message?.toString() ?? ''}
            shrink={shrink}
            disabled
          />

          <Grid item xs={12} container spacing={2} alignItems="center">
            <Grid item xs={12} md={11}>
              <CustomTextField
                type="coordenada"
                control={form.control}
                name="coordenadas"
                defaultValue={form.getValues().coordenadas || ''}
                size={gridSize}
                label="Coordenadas del Cliente"
                error={errors.coordenadas}
                startAdornment={
                  <InputAdornment position="start">
                    <SvgIcon fontSize="small">
                      <GlobeEuropeAfricaIcon />
                    </SvgIcon>
                  </InputAdornment>
                }
                helperText={errors.coordenadas?.message}
                disabled
              />
            </Grid>
            <Grid item xs={12} md={1}>
              <IconBtnModalMapComponent
                coords={
                  `${latLng.lat},${latLng.lng}` ||
                  `${form.getValues().coordenadas}` ||
                  ''
                }
                btnColor="info"
                showCustomMap
                customMap={
                  <Map
                    coordenadas={latLng}
                    napsByCity={napsByCity || []}
                    setLatLng={setLatLng}
                    canDragMarker={false}
                  />
                }
              />
            </Grid>
          </Grid>
        </>
      </>

      {/* ------- Activacion --------- */}
      <TabTextLabel text="ACTIVACIÓN" pt="42px" />
      <>
        <CustomTextFieldNoForm
          label="Nodo"
          value={ordenTrabajo?.nodo}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />
        <CustomTextFieldNoForm
          label="OLT"
          value={ordenTrabajo?.olt}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />
        <CustomTextFieldNoForm
          label="Router"
          value={ordenTrabajo?.router}
          size={gridSize}
          disabled
          shrink={shrink}
        />
        <CustomTextFieldNoForm
          label="NAP"
          value={ordenTrabajo?.nap}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />
        <CustomTextFieldNoForm
          label="Puerto"
          value={ordenTrabajo?.puerto}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />
        <CustomTextFieldNoForm
          label="Distancia a la NAP"
          value={ordenTrabajo?.distancia}
          size={gridSize}
          disabled
          shrink={shrink}
        />
        <CustomTextFieldNoForm
          label="IPv4"
          value={ordenTrabajo?.ipv4_actual}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />
        <CustomTextFieldNoForm
          label="IPv6"
          value={ordenTrabajo?.ipv6_actual}
          size={gridSizeMdLg6}
          disabled
          shrink={shrink}
        />
        <CustomTextFieldNoForm
          label="PPPoE"
          value={ordenTrabajo?.pppoe}
          size={gridSize}
          disabled
          shrink={shrink}
        />
        <CustomTextFieldNoForm
          label="PPPassword"
          value={ordenTrabajo?.pppassword}
          size={gridSize}
          disabled
          shrink={shrink}
        />
      </>
    </>
  );
};

export default OperacionPrerechazadaInstallDetail;
